import React, { ReactNode } from 'react';

import PropTypes from 'prop-types';

import theme, { StylableComponent } from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';

import { optionShape } from '../helpers/propTypes';
import { Permission } from '../types';

type PermissionOptionLabelProps = StylableComponent<HTMLSpanElement> & {
  label?: ReactNode;
  disabled?: boolean;
};

const PermissionOptionLabel = ({
  style,
  label,
  disabled,
  ...props
}: PermissionOptionLabelProps) => (
  <span
    css={[
      {
        ...theme.typography.bodySmall,
        color: theme.colors.charcoal700,
        height: 24,
        userSelect: 'none',
      },
      disabled && {
        color: theme.colors.charcoal400,
      },
      style,
    ]}
    {...props}
  >
    {label}
  </span>
);

PermissionOptionLabel.propTypes = {
  /**
   * Permission option label
   */
  label: PropTypes.node,
  /**
   * Option is disabled
   */
  disabled: PropTypes.bool,
};

type PermissionOptionProps = StylableComponent<HTMLSpanElement> & {
  permission: Permission;
  disabled?: boolean;
};

const PermissionOption = ({ permission, ...props }: PermissionOptionProps) =>
  permission.tooltip ? (
    <Tooltip content={permission.tooltip} {...permission.tooltipProps}>
      <PermissionOptionLabel label={permission.label} {...props} />
    </Tooltip>
  ) : (
    <PermissionOptionLabel label={permission.label} {...props} />
  );

PermissionOption.propTypes = {
  /**
   * Permission option
   */
  permission: optionShape,
  /**
   * Option is disabled
   */
  disabled: PropTypes.bool,
};

export default PermissionOption;
